export const VEHICLE_IMAGES = {
  business: "https://static.prod-images.emergentagent.com/jobs/b1c141c5-86e9-4a23-a7ec-75b795a6b2ac/images/9af0949ea9f863f1c99527551feff210d0b78bc7d8a95c9c6863d157fdc529aa.jpeg",
  vip: "https://static.prod-images.emergentagent.com/jobs/b1c141c5-86e9-4a23-a7ec-75b795a6b2ac/images/a52200be55aa87e38a052ebe9329f49da266b54273edb6d8e77b711888a7677b.jpeg",
  van: "https://static.prod-images.emergentagent.com/jobs/b1c141c5-86e9-4a23-a7ec-75b795a6b2ac/images/31586f862b6c605db26b947b8e1bff900d61edf71d48fb970cc3a87f5b6e5191.jpeg",
  actyon: "https://static.prod-images.emergentagent.com/jobs/b1c141c5-86e9-4a23-a7ec-75b795a6b2ac/images/aa9f5f5323d27ccde1aba36b9de9a2f7a468863a6dc55113fbefddfbb55a7f8e.jpeg",
  modely: "https://static.prod-images.emergentagent.com/jobs/b1c141c5-86e9-4a23-a7ec-75b795a6b2ac/images/15ee4fb2d8019b65c0f270a7ee9cc2f77216e757510bcaefcd561804dc1bed40.jpeg",
  model3: "https://static.prod-images.emergentagent.com/jobs/b1c141c5-86e9-4a23-a7ec-75b795a6b2ac/images/31b29bbfcc64bca0c23899718e84c165f8e69bd7c158d252f017b6b25fb47775.jpeg",
};

export const VEHICLE_META = {
  business: { passengers: 3, luggage: 3, comfort: 4, price: 2 },
  vip: { passengers: 3, luggage: 3, comfort: 5, price: 4 },
  van: { passengers: 7, luggage: 7, comfort: 4, price: 3 },
  actyon: { passengers: 4, luggage: 4, comfort: 4, price: 2 },
  modely: { passengers: 4, luggage: 3, comfort: 5, price: 3 },
  model3: { passengers: 3, luggage: 3, comfort: 4, price: 2 },
};
